import CopyKeywordMapping from './copyKeywordMapping'
export default CopyKeywordMapping
